// utils/loading.js
import { Loading } from 'element-ui'; // Vue 2 使用 element-ui

let loadingInstance = null;      // 存储 Loading 实例
let requestCount = 0;            // 请求计数器

// 开始 Loading
const startLoading = () => {
  // Vue 2 中使用 Element UI 的 Loading.service 方法[citation:1][citation:5]
  loadingInstance = Loading.service({
    lock: true,                 // 锁定屏幕滚动
    text: '加载中...',           // 自定义文本
    background: 'rgba(0, 0, 0, 0.3)' // 背景色
  });
};

// 结束 Loading
const endLoading = () => {
  if (loadingInstance) {
    loadingInstance.close();     // 关闭 Loading
    loadingInstance = null;
  }
};

// 暴露给外部调用的显示方法（使用计数器）
export const showLoading = () => {
  if (requestCount === 0) {
    startLoading();
  }
  requestCount++;
};

// 暴露给外部调用的关闭方法
export const hideLoading = () => {
  if (requestCount <= 0) return;
  requestCount--;
  if (requestCount === 0) {
    endLoading();
  }
};